import Vue from 'vue';

export default {
    async inserted(el, { value }) {
        await Vue.nextTick();
        if(value && location.hash.match(new RegExp(value))) {
            window.scrollBy(0, el.getBoundingClientRect().top - 180);
        }
    }
}
